import { API_URL } from "config";
import Http from "util/https";
import { CompanyConditionListResponse, CompanyConditionParams, CompanyInfo } from "../types";

/**
 * ジョイフル用設定画面用・登録企業リスト取得API
 * @param params 企業リスト取得リクエストパラメータ
 * @returns Promise<CompanyStoreInfo[]> レスポンスステータスコード
 */
const companyConditionApi = async (params: CompanyConditionParams): Promise<CompanyInfo[]> => {
  console.log('companyConditionApi params:', params);
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/joyful/company/condition`;
  const res = await http.post<{company_list: CompanyConditionListResponse[]}>(url, params);
  console.log(res);

  // const allStores: CompanyStoreInfo[] = res.data.company_list.flatMap((company) => company.stores);
  const companies: CompanyInfo[] = res.data.company_list.map((c) => ({
    companyCd: c.company_cd,
    companyName: c.company_name,
    stores: c.stores.map(s => ({
      clientCd: s.client_cd,
      storeName: s.store_name,
    }))
  }));

  return companies;
};

export default companyConditionApi;
